// Primary Chinese Data - Main Export File
// This file imports and exports all primary Chinese grade data

import { p1DataPart1, p1DataPart2 } from './primaryChinese/p1DataPart1';
import { p2DataPart1, p2DataPart2 } from './primaryChinese/p2DataPart1';
import { p3DataPart1, p3DataPart2 } from './primaryChinese/p3DataPart1';
import { p4DataPart1, p4DataPart2 } from './primaryChinese/p4DataPart1';
import { p5DataPart1, p5DataPart2 } from './primaryChinese/p5DataPart1';
import { p6DataPart1, p6DataPart2 } from './primaryChinese/p6DataPart1';

// Combine P1 data from parts
const p1Data = {
  ...p1DataPart1,
  languageUsage: [...p1DataPart1.languageUsage, ...p1DataPart2.languageUsage]
};

// Combine P2 data from parts
const p2Data = {
  ...p2DataPart1,
  languageUsage: [...p2DataPart1.languageUsage, ...p2DataPart2.languageUsage]
};

// Combine P3 data from parts
const p3Data = {
  ...p3DataPart1,
  languageUsage: [...p3DataPart1.languageUsage, ...p3DataPart2.languageUsage]
};

// Combine P4 data from parts
const p4Data = {
  ...p4DataPart1,
  languageUsage: [...p4DataPart1.languageUsage, ...p4DataPart2.languageUsage]
};

// Combine P5 data from parts
const p5Data = {
  ...p5DataPart1,
  languageUsage: [...p5DataPart1.languageUsage, ...p5DataPart2.languageUsage]
};

// Combine P6 data from parts
const p6Data = {
  ...p6DataPart1,
  languageUsage: [...p6DataPart1.languageUsage, ...p6DataPart2.languageUsage]
};

export const primaryChineseData = {
  p1: p1Data,
  p2: p2Data,
  p3: p3Data,
  p4: p4Data,
  p5: p5Data,
  p6: p6Data
}; 